module.exports = __webpack_public_path__ + "img/business-4.a0254b94.png";